import { css } from "../../../../../styled-system/css";
import { t } from "../../../../libs/i18n";
import { Heading } from "./heading";

export const DefaultCampaignDetail = () => {
  return (
    <>
      <Heading>{t("ポイント抽選とは")}</Heading>
      <p>
        {t(
          "アプリ内で1回限り抽選に参加できます。\n当選者には2,000ポイントが即時付与されます。\n初回抽選で落選した場合でも、令和7年1月31日の再抽選で当選するチャンスがあります。\n獲得したポイントは、令和7年1月6日から令和7年2月28日まで対象店舗で1ポイント＝1円として利用できます。",
        )}
      </p>
      <Heading>{t("参加の方法")}</Heading>
      <div
        className={css({
          display: "flex",
          flexDirection: "column",
          gap: "8px",
        })}
      >
        <p>
          {t(
            "抽選への参加はとても簡単です。ホーム画面の「抽選に参加」ボタンをタップして、ポイントを獲得しましょう！",
          )}
        </p>

        <Heading>{t("スケジュール")}</Heading>
        <p
          className={css({
            fontSize: "14px",
            color: "text.secondary",
          })}
        >
          {t(
            "※以下のスケジュールは予定であり、変更となる可能性があります。ポイント配布予定の上限に達し次第、即時抽選は終了します。",
          )}
        </p>
        <div
          className={css({
            mt: "8px",
          })}
        >
          <p>{t("令和6年11月18日：即時抽選キャンペーン開始")}</p>
          <p>{t("令和7年1月6日：ポイントの利用開始")}</p>
          <p>{t("令和7年1月25日：即時抽選キャンペーン終了")}</p>
          <p>{t("令和7年1月31日：一斉再抽選の実施")}</p>
        </div>
      </div>
    </>
  );
};
